import React, { Component, Fragment } from 'react'
import { Link } from 'react-router-dom'
import firebase from '../components/firebase'
import ItemList from '../components/itemList'
import Modal from '../components/utils/modal'


export default class Administration extends Component {
   constructor(props) {
     super(props)
   
     this.state = {
        listItem: [],
        email: '',
        password: '',
        showModal: false,
        logged: false,
        register: false
     }
   }

  componentDidMount = (props) => {
    const isLogged = sessionStorage.getItem('logged')
    if (isLogged) {
      this.setState({
        logged: true
      })
    }
    const unsubscribe = firebase
      .firestore()
      .collection('casamentokaju')
      .onSnapshot(snapshot => {
        const listItem = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }))
        this.setState({listItem})
      })
    return () => unsubscribe()
  }

  onChangeInput = e => {
    const {name, value} = e.target

    this.setState({
      [name]: value
    })
  }

  onClickPin = ({item}, bool) => {
    const updateItem = { ...item, show: bool}
    if (typeof window !== `undefined`) {
      firebase
        .firestore()
        .collection("casamentokaju")
        .doc(item.id)
        .update(updateItem)
    }
  }

  closeModal = () => {
    this.setState({
      showModal: false
    })
  }

  renderModal = () => {
    return (
      <Modal closeModal={this.closeModal}>
        <h1>Cadastro</h1>
        <br />
        <p>Seu cadastro foi criado com sucesso.</p>
      </Modal>
    )
  }

  onSubmitRegisterClick = e => {
    e.preventDefault()
    const {email, password} = this.state
    firebase.auth().createUserWithEmailAndPassword(email, password)
      .then(res => {
        this.setState({
          register: false,
          showModal: true,
          email: '',
          password: ''
        })
      })
      .catch((error) => {
        const errorCode = error.code
        const errorMessage = error.message
        if (errorCode === 'auth/weak-password') {
          alert('A senha é fraca demais :(')
        } else {
          alert(errorMessage)
        }
          console.log(error)
        })
  }

  onsubmitLogin = e => {
    e.preventDefault()
    const {email, password} = this.state
    firebase.auth().signInWithEmailAndPassword(email, password)
      .then(resp => {
        window.sessionStorage.setItem('logged', true)
        this.setState({logged: true})
      })
      .catch((error) => {
        var errorCode = error.code;
        var errorMessage = error.message;
          alert(`Erro. Login não efetuado - ${errorCode} - ${errorMessage}`)
      })
  }

  render () {
    const {listItem, email, password, showModal, logged, register} = this.state

    return (
      <div className='full-height'>
        {showModal && (this.renderModal())}
        {logged ? (
          <section className='admin-section'>
            <h2>Administração</h2>
            <div className='tab-content'>
              <ItemList completeList={listItem} onPinClick={this.onClickPin}/>
            </div>
          </section>
        ) : (
          <section className='login'>
            <div className='container'>
              {register ? (
                <Fragment>
                  <h2>Cadastro de Usuário</h2>
                  <form onSubmit={e => this.onSubmitRegisterClick(e)}>
                    <label>
                      <span>Email</span>
                      <input
                        className='input'
                        name='email'
                        value={email}
                        type='email'
                        autoComplete='off'
                        onChange={e => this.onChangeInput(e)} />
                    </label>
                    <label>
                      <span>Senha</span>
                      <input
                        className='input'
                        name='password'
                        value={password}
                        type='password'
                        autoComplete='off'
                        onChange={e => this.onChangeInput(e)} />
                    </label>
                    <Link to="/" className="button voltar"> Voltar </Link>
                    <button className='button submit' type='submit'>Entrar</button>
                  </form>
                </Fragment>
                ) : (
                <Fragment>
                  <h2>Login Adminsitrativo</h2>
                  <form onSubmit={e => this.onsubmitLogin(e)}>
                    <label>
                      <span>Email</span>
                      <input
                        className='input'
                        name='email'
                        value={email}
                        type='email'
                        autoComplete='off'
                        onChange={e => this.onChangeInput(e)} />
                    </label>
                    <label>
                      <span>Senha</span>
                      <input
                        className='input'
                        name='password'
                        value={password}
                        type='password'
                        autoComplete='off'
                        onChange={e => this.onChangeInput(e)} />
                    </label>
                    <Link to="/" className="button voltar"> Voltar </Link>
                    <button className='button submit' type='submit'>Entrar</button>
                  </form>
                </Fragment>
                )}
            </div>
          </section>
        )}
      </div>
    )
  }
}






// WEBPACK FOOTER //
// ./src/components/Administration.js